import { AMCF_TAB_STORAGE_KEY } from './amcf-tab-coordinator.constants';
import type { AmcfTabMessage } from './amcf-tab-coordinator.models';
import { parseTabMessage } from './amcf-tab-coordinator-parse.util';

type StorageEnvelope = {
  ts: number;
  message: unknown;
};

export function writeTabMessageToStorage(message: AmcfTabMessage, storage?: Storage): void {
  const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
  if (!store) {
    return;
  }
  const envelope: StorageEnvelope = { ts: Date.now(), message };
  try {
    store.setItem(AMCF_TAB_STORAGE_KEY, JSON.stringify(envelope));
  } catch {
    // quota / private mode
  }
}

export function parseTabStorageEvent(event: StorageEvent, now = Date.now()): AmcfTabMessage | null {
  if (event.key !== AMCF_TAB_STORAGE_KEY || event.newValue == null) {
    return null;
  }
  try {
    const parsed = JSON.parse(event.newValue) as StorageEnvelope;
    return parseTabMessage(parsed?.message, now);
  } catch {
    return null;
  }
}
